module.exports = __webpack_public_path__ + "img/selected4-min.0bc0913c.png";